import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'
import { APP_LABEL } from '../constants/deviceStatus/statusLabels'
import { APP_STATUS } from '../constants/deviceStatus/deviceStatus'

export default {

  data: function () {
    return {
      deviceList: [],
      currentPage: 1,
      perPage: 20,
      hasNextPage: false,
      startOffset: 0,
      pageOptions: [
        {text: 5, value: 5},
        {text: 10, value: 10},
        {text: 20, value: 20},
        {text: 50, value: 50},
        {text: 100, value: 100},
        {text: 200, value: 200}
      ],
      sortOption: 'lastLeakMessage',
      sortOptions: [
        {
          text: 'Last Leak Message',
          value: 'lastLeakMessage'
        },
        {
          text: 'Last Status Message',
          value: 'lastStatusMessage'
        }
      ],
      filterOption: null,
      filterOptions: [
        {
          text: 'All',
          value: null
        },
        {
          text: APP_LABEL[APP_STATUS.ENG_VISIT],
          value: APP_STATUS.ENG_VISIT
        },
        {
          text: APP_LABEL[APP_STATUS.CUST_REPAIRED],
          value: APP_STATUS.CUST_REPAIRED
        },
        {
          text: APP_LABEL[APP_STATUS.ENG_VISIT_NO_LEAK],
          value: APP_STATUS.ENG_VISIT_NO_LEAK
        },
        {
          text: APP_LABEL[APP_STATUS.LEAK_ACTIVE],
          value: APP_STATUS.LEAK_ACTIVE
        },
        {
          text: APP_LABEL[APP_STATUS.LEAK_INACTIVE],
          value: APP_STATUS.LEAK_INACTIVE
        },
        {
          text: APP_LABEL[APP_STATUS.ENGINEER_REPAIRED],
          value: APP_STATUS.ENGINEER_REPAIRED
        },
        {
          text: APP_LABEL[APP_STATUS.LOW_SIGNAL],
          value: APP_STATUS.LOW_SIGNAL
        },
        {
          text: APP_LABEL[APP_STATUS.NO_SIGNAL],
          value: APP_STATUS.NO_SIGNAL
        },
        {
          text: APP_LABEL[APP_STATUS.ON_PIPE],
          value: APP_STATUS.ON_PIPE
        },
        {
          text: APP_LABEL[APP_STATUS.WAITING_ON_PIPE],
          value: APP_STATUS.WAITING_ON_PIPE
        },
        {
          text: APP_LABEL[APP_STATUS.INSTALLED],
          value: APP_STATUS.INSTALLED
        },
        {
          text: APP_LABEL[APP_STATUS.HIGH_USAGE],
          value: APP_STATUS.HIGH_USAGE
        }
      ],
      filter: null,
      fields: {
        leakbotId: {
          label: 'LeakBot ID',
          sortable: false
        },
        serialNumber: {
          label: 'Serial Number',
          sortable: false
        },
        deviceName: {
          label: 'Sigfox ID',
          sortable: false
        },
        fname: {
          label: 'Forename',
          sortable: false
        },
        lname: {
          label: 'Surname',
          sortable: false
        },
        leakCount: {
          label: 'Leak count',
          sortable: false
        },
        lastStatusMessage: {
          label: 'Last status message',
          sortable: false
        },
        lastLeakMessage: {
          label: 'Last leak message',
          sortable: false
        },
        customerStatus: {
          label: 'Customer status',
          sortable: false
        }
      }
    }
  },
  mounted () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      this.fetchUserData()
    }
  },
  methods: {
    fetchUserData () {
      let options = {}
      options.fetch_size = this.perPage.toString()
      options.start_offset = this.startOffset.toString()
      options.order_by = this.sortOption
      if (this.filterOption !== null) {
        if (this.filterOption === 'FittingError7') {
          options.filter_by = this.filterOption
        } else {
          options.leak_status = this.filterOption
        }
      }
      // console.log(options)
      this.$store.dispatch(APIEvent.FETCH_DEVICES, options)
        .then(res => {
          // console.log(res)
          this.hasNextPage = res.data.LastPage === '0'
          this.deviceList = res.data.list.record
          if (typeof this.deviceList !== 'undefined') {
            this.addVipHiglighting()
          }
        })
        .catch(function (err) {
          let msg = 'The list can not be refreshed. Please check and try again :: '
          msg += err.message
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
        this.currentPage++
      } else {
        this.startOffset -= this.perPage
        this.currentPage--
      }
      this.fetchUserData(this.startOffset, this.requestData)
    },
    addVipHiglighting: function () {
      for (var i = 0; i < this.deviceList.length; i++) {
        let record = this.deviceList[i]
        if (record.isVIP === '1') {
          record._rowVariant = 'danger'
        }
      }
    }
  }
}
